import { render, staticRenderFns } from "./attr-edit.vue?vue&type=template&id=3b86d734&scoped=true&"
import script from "./attr-edit.vue?vue&type=script&lang=js&"
export * from "./attr-edit.vue?vue&type=script&lang=js&"
import style0 from "./attr-edit.vue?vue&type=style&index=0&id=3b86d734&scoped=true&lang=css&"
import style1 from "./attr-edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86d734",
  null
  
)

export default component.exports